module.exports = __webpack_public_path__ + "cfa4d2d15388c09a34146a735f92d20c.svg";